<template>
    <div class="container" style="float: none;">
        <loader v-if="mediaLoading"/>
        <div v-for="mediaType in docMediaTypes" class="form-group" :key="mediaType.index">
            <label class="col-md-2 control-label text-label">{{mediaType.name}}</label>
            <div class="col-md-10">
                <table v-show="hasTableItems(mediaType.mediaTypeId)" class="table">
                    <thead>
                        <tr v-if="mediaType.name === 'Shape Files'">
                                <th>Download</th>
                                <th>File Name</th>
                                <th>Status</th>
                                <th>Layers Processed</th>
                                <th>Layer Count</th>
                                <th>Processing Complete Date</th>
                                <th>Comment</th>
                                <th>Uploaded By</th>
                                <th v-if="!formDisabled || isAdmin">Delete</th>
                        </tr>
                        <tr v-else>
                            <th style="width:10%">Download</th>
                            <th style="width:30%">File Name</th>
                            <th style="width:30%">Comment</th>
                            <th style="width:20%">Uploaded By</th>
                            <th v-if="!formDisabled || isAdmin" style="width:10%">Delete</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="mediaItem in mediaList.filter(m => mediaFilter(m.mediaTypeId, mediaType.mediaTypeId))" :key="mediaItem.mediaId">
                            <td>
                                <div style="text-align: center;">
                                    <a class="fa fa-cloud-download" style="font-size: 18px;" target="_blank" v-on:click="mediaDownloadRow(mediaItem.mediaId, mediaItem.mediaTypeId, mediaType.mediaSubtype, mediaItem.parentId, mediaItem.filename)"></a>
                                </div>
                            </td>
                            <td>{{mediaItem.filename}}</td>
                            <td v-if="mediaType.name === 'Shape Files'">{{mediaItem.shapeFileCurrentLayerGisJobStatus}}</td>
                            <td v-if="mediaType.name === 'Shape Files'">{{mediaItem.shapeFileCurrentLayerIndex}}</td>
                            <td v-if="mediaType.name === 'Shape Files'">{{mediaItem.shapeFileLayerCount}}</td>
                            <td v-if="mediaType.name === 'Shape Files'">{{mediaItem.shapeFileProcessingCompleteDate ? mediaItem.shapeFileProcessingCompleteDate.format('MM/DD/YYYY, hh:mm A') : ''}}</td>
                            <td>{{mediaItem.comment}}</td>
                            <td>{{mediaItem.createdBy}}</td>
                            <td v-if="!formDisabled || isAdmin">
                                <div style="text-align: center;" v-if="mediaType.mediaTypeId === mediaItem.mediaTypeId">
                                    <a class="fa fa-ban" style="font-size: 18px;" target="_blank" v-on:click="mediaRemove(mediaItem.mediaId)"></a>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div v-show="!hasTableItems(mediaType.mediaTypeId)">
                    <label>No matching records</label>
                </div>
            </div>
        </div>

        <div class="form-group">
            <label class="col-md-2">Add File</label>
            <div class="col-md-10">
                <form v-on:submit.prevent class="form" id="documentForm" data-vv-scope="mediaFile">
                    <div class="row">
                        <div class="col-md-2">
                            <div class="form-group" v-bind:class="{ 'has-error': errors.has('mediaFile.mediaType') }">
                                <label>Type</label>
                                <select name="mediaType" class="form-control" v-model="mediaTypeId" v-validate="'required'">
                                    <option disabled value=''>Select a value</option>
                                    <option v-for="mediaType in docMediaTypes" :value="mediaType.mediaTypeId" :key="mediaType.mediaTypeId">
                                        {{mediaType.name}}
                                    </option>
                                </select>
                                <div><span v-show="errors.has('mediaFile.mediaType')" class="has-error">File type is required</span></div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group" v-bind:class="{ 'has-error': errors.has('mediaFile.newFile') }">
                                <label>File</label><br>
                                <input name="newFile" ref="newFile" class="file" type="file" v-validate="'required'">
                                <div><span v-show="errors.has('mediaFile.newFile')" class="has-error">File is required</span></div>
                            </div>
                        </div>
                        <div class="col-md-5">
                            <div class="form-group">
                                <label>Comment</label>
                                <input type="text" class="form-control" v-model="comment">
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-md-3"></div>
                        <div class="col-md-8">
                            <div v-show="errors.any('mediaFile')">
                                <span class="has-error">Validation issues must be corrected prior to upload</span>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-md-3"></div>
                        <div class="col-md-8">
                            <div v-show="serverErrorList.length > 0">
                                <span class="has-error">Validation issues must be corrected prior to submit</span>
                                <ul class="has-error">
                                    <li v-for="serverError in serverErrorList" :key="serverError">{{ serverError }}</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <button class="btn btn-primary" v-on:click="addFile">Upload</button>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import mediaService from '../../services/mediaService'
import loggingService from '../../services/util/loggingService'
import loader from '@/components/Loader.vue'

export default {
    name: 'undertakingDocuments',
    components: {
        loader
    },
    data: function () {
        return {
            isDebug: false,
            mediaLoading: false,
            serverErrorList: [],
            mediaList: [],
            comment: '',
            mediaTypeId: '',
            mediaSubtypeId: '',
            filename: '',
            mediaRefreshIntervalId: null,
            mediaRefreshCount: 0
        }
    },
    props: {
        parentId: {},
        undertaking: {},
        loadOnMount: { default: true },
        formDisabled: { default: false },
        isAdmin: { default: false }
    },
    computed: {
        docMediaTypes: function () {
            var list = [
                {
                    name: 'Shape Files',
                    mediaTypeId: mediaService.mediaType.UndertakingShapeFiles,
                    enabled: true
                },
                {
                    name: 'Discovery Plan',
                    mediaTypeId: mediaService.mediaType.UndertakingDiscoveryPlan,
                    enabled: this.undertaking.reqDiscoveryPlan ? this.undertaking.reqDiscoveryPlan : false
                },
                {
                    name: 'Data Discovery Plan',
                    mediaTypeId: mediaService.mediaType.UndertakingDataDiscoveryPlan,
                    enabled: this.undertaking.reqDataDiscoveryPlan ? this.undertaking.reqDataDiscoveryPlan : false
                },
                {
                    name: 'Visual Contrast Rating',
                    mediaTypeId: mediaService.mediaType.UndertakingVisualContrastRating,
                    enabled: this.undertaking.reqVisualContrastRating ? this.undertaking.reqVisualContrastRating : false
                },
                {
                    name: 'Compliance Check',
                    mediaTypeId: mediaService.mediaType.UndertakingComplianceCheck,
                    enabled: this.undertaking.reqComplianceCheck ? this.undertaking.reqComplianceCheck : false
                },
                {
                    name: 'HABS/HAER Record',
                    mediaTypeId: mediaService.mediaType.UndertakingHabsHaerRecord,
                    enabled: this.undertaking.reqHabsHaerRecord ? this.undertaking.reqHabsHaerRecord : false
                },
                {
                    name: 'Undertaking Authorization',
                    mediaTypeId: mediaService.mediaType.UndertakingAuthorization,
                    enabled: true
                },
                {
                    name: 'MOA',
                    mediaTypeId: mediaService.mediaType.UndertakingMoa,
                    enabled: true
                },
                {
                    name: 'PA',
                    mediaTypeId: mediaService.mediaType.UndertakingPa,
                    enabled: true
                },
                {
                    name: 'Supporting Documents',
                    mediaTypeId: mediaService.mediaType.UndertakingSupportingDocuments,
                    enabled: true
                }
            ]
            return list.filter(m => m.enabled)
        },
        continueMediaRefreshCheck: function () {
            return this.mediaList && this.mediaList.length > 0 && this.mediaRefreshCount < 100 && this.mediaList.some(x => {
                return !x.shapeFileProcessingCompleteDate && x.isShapeFile
            })
        },
        stopMediaRefreshCheck: function () {
            return this.mediaList && this.mediaList.length > 0 && !this.mediaList.some(x => {
                return !x.shapeFileProcessingCompleteDate && x.isShapeFile
            })
        }
    },
    mounted () {
        if (this.loadOnMount) this.loadData()
    },
    methods: {
        log (message) {
            loggingService.log(this.isDebug, 'Site Form Documents', message)
        },
        loadMedia (mediaTypeId, mediaSubtypeId, parentId) {
            this.log('looking for parent: ' + parentId)
            return mediaService.list(this.$http, mediaTypeId, mediaSubtypeId, parentId).then(result => {
                this.mediaList = this.mediaList.concat(result.data)
                return result
            })
        },
        loadData () {
            this.mediaLoading = true
            var promises = []
            this.mediaList = []
            this.docMediaTypes.forEach(mediaType => {
                promises.push(this.loadMedia(mediaType.mediaTypeId, null, this.parentId))
            })
            Promise.all(promises).then(result2 => {
                this.log('After load, media list count: ' + this.mediaList.length)
                this.mediaLoading = false
                this.mediaRefresh()
            })
        },
        addFile () {
            this.$validator.validateAll('mediaFile').then(result => {
                this.log(`Validiting and Submitting File.`)
                if (result) {
                    var file = this.$refs['newFile'].files[0]
                    this.log(`Adding file. Type: ${this.mediaTypeId} Comment: ${this.comment} Name: ${file.name}`)
                    mediaService.putFile(this.$http, this.mediaTypeId, this.mediaSubtypeId, this.parentId, file, this.comment).then(result => {
                        this.loadData()
                        this.resetFileUploadForm()
                        this.errors.clear()
                    })
                } else {
                    this.log('Submit File - Invalid Form')
                }
            })
        },
        hasTableItems (listMediaTypeId) {
            if (this.mediaList.find(x => { return x.mediaTypeId === listMediaTypeId })) {
                return true
            } else if (listMediaTypeId === mediaService.mediaType.UndertakingMoa && this.mediaList.find(x => { return x.mediaTypeId === mediaService.mediaType.Moa })) {
                return true
            } else if (listMediaTypeId === mediaService.mediaType.UndertakingPa && this.mediaList.find(x => { return x.mediaTypeId === mediaService.mediaType.Pa })) {
                return true
            } else {
                return false
            }
        },
        mediaFilter (itemMediaId, listMediaId) {
            if (listMediaId === itemMediaId) {
                return true
            } else if (listMediaId === mediaService.mediaType.UndertakingMoa && itemMediaId === mediaService.mediaType.Moa) {
                return true
            } else if (listMediaId === mediaService.mediaType.UndertakingPa && itemMediaId === mediaService.mediaType.Pa) {
                return true
            } else {
                return false
            }
        },
        mediaDownloadRow (mediaId) {
            var mediaItem = this.mediaList.find(x => { return x.mediaId === mediaId })
            this.log(`mediaDownloadRow - mediaId: ${mediaItem.mediaId} , mediaTypeId: ${mediaItem.mediaTypeId}, parentId: ${mediaItem.parentId}`)
            mediaService.get(this.$http, mediaItem.mediaId, mediaItem.mediaTypeId, mediaItem.mediaSubtypeId, mediaItem.parentId).then(function (response) {
                mediaService.saveFileToDownload(response, mediaItem.filename)
            })
        },
        resetFileUploadForm () {
            document.forms['documentForm'].reset()
            this.mediaTypeId = ''
            this.mediaSubtypeId = null
            this.comment = ''
            this.$refs['newFile'].value = null
        },
        mediaRemove (mediaId) {
            if (confirm('Are you sure you want to remove this file/document?')) {
                mediaService.removeByMediaId(this.$http, mediaId).then(result => {
                    this.loadData()
                })
            }
        },
        refreshShapeFileMedia () {
            this.log('refreshing shape files:')
            this.mediaList = this.mediaList.filter(x => x.mediaTypeId !== mediaService.mediaType.InvestigationShapeFiles)
            return this.loadMedia(mediaService.mediaType.InvestigationShapeFiles, null, this.parentId)
        },
        mediaRefresh () {
            this.mediaRefreshCount = 0
            if (this.mediaRefreshIntervalId) clearInterval(this.mediaRefreshIntervalId)
            this.$emit('mediaRefreshStarted')
            if (this.stopMediaRefreshCheck) {
                this.$emit('mediaRefreshComplete')
                return
            }
            this.mediaRefreshIntervalId = setInterval(() => {
                if (this.continueMediaRefreshCheck) {
                    this.log('media refresh count:' + this.mediaRefreshCount)
                    this.mediaRefreshCount++
                    this.refreshShapeFileMedia().then(response => {
                        if (this.stopMediaRefreshCheck) {
                            clearInterval(this.mediaRefreshIntervalId)
                            this.$emit('mediaRefreshComplete')
                        }
                    })
                } else {
                    clearInterval(this.mediaRefreshIntervalId)
                    this.$emit('mediaRefreshComplete')
                }
            }, 5000)
        }
    }
}
</script>



// WEBPACK FOOTER //
// UndertakingDocuments.vue?4c528a8a